import React from 'react'
import { List, Stack, Typography } from '@mui/material'
import { TransactionListItem } from './TransactionListItem'
import { format } from 'date-fns'
import EmptyList from '@components/EmptyList'
import ExchangeListItem from './ExchangeListItem'
import SwapListItem from './SwapListItem'
import {
  ExchangeActivity,
  Swap,
  TransactionActivity,
} from '@plug-core/interfaces/transactionActivity'
import { logger } from '@plug-core/logger'
import { HistoryItem } from '@plug-core/hooks/useWalletTransactionHistory'
import { groupBy } from '@plug-core/utils/miscHelper'
import { useTranslation } from 'react-i18next'

interface IProps {
  transactions: HistoryItem[]
}

export const TransactionList = ({ transactions }: IProps) => {
  const { t } = useTranslation()

  const renderTransactionsPerMonth = () => {
    let transactionsPerMonth = groupBy(transactions, (t) => {
      try {
        if (typeof t.item.timestamp === 'number') {
          const milliseconds = Number(t.item.timestamp) / 1_000_000
          return format(new Date(milliseconds), 'MMMM yyyy')
        } else {
          return format(t.item.timestamp, 'MMMM yyyy')
        }
      } catch (e) {
        logger.debug('Could not get timestamp for transaction', {
          transaction: t,
        })
        return ''
      }
    })

    return Object.entries(transactionsPerMonth).map(([month, transactions]) => {
      return (
        <Stack key={month} component={List} spacing={1.2} disablePadding pb={1}>
          <Typography variant="h6">{month}</Typography>

          {transactions.map((transaction) => {
            if (transaction.kind === 'swap') {
              return (
                <SwapListItem
                  key={`${(transaction.item as Swap).timestamp}-${(transaction.item as Swap).token0}-${(transaction.item as Swap).token1}`}
                  swapDetails={transaction.item as Swap}
                />
              )
            } else if (transaction.kind === 'transaction') {
              return (
                <TransactionListItem
                  key={`${(transaction.item as TransactionActivity).transactionId}-${(transaction.item as TransactionActivity).tokenLedgerId}`}
                  transaction={transaction.item as TransactionActivity}
                />
              )
            }

            return (
              <ExchangeListItem
                key={(transaction.item as ExchangeActivity).exchangeId}
                exchange={transaction.item as ExchangeActivity}
              />
            )
          })}
        </Stack>
      )
    })
  }

  if (transactions.length === 0)
    return (
      <EmptyList
        emoji="🥹"
        title={t('transactionHistory.empty')}
        description={t('transactionHistory.emptyMessage')}
      />
    )

  return (
    <Stack component={List} spacing={1.2} disablePadding>
      {renderTransactionsPerMonth()}
    </Stack>
  )
}
